import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {AuthService} from '../../../../../../chat-common/src/lib/services/auth.service';
import {ProfileComponent} from './profile/profile.component';
import {NgIf} from '@angular/common';
import {SubscriptionDetailsComponent} from './subscription-details/subscription-details.component';
import {user} from '@angular/fire/auth';
import {UserService} from '../../../../../../chat-common/src/lib/services/user.service';

@Component({
  selector: 'app-sidemenu',
  standalone: true,
  imports: [ProfileComponent, SubscriptionDetailsComponent, NgIf],
  templateUrl: './sidemenu.component.html'
})
export class SidemenuComponent implements OnInit {

  @Output()
  onBackClick: EventEmitter<any> = new EventEmitter();
  showProfile = false;
  showSubscription = false;
  isDesktop = false;

  constructor(private authService: AuthService, protected userService: UserService) {}

  ngOnInit(): void {
    // Show Profile by default on desktop (md+ ~ >=768px)
    this.isDesktop = typeof window !== 'undefined' && !!window.matchMedia && window.matchMedia('(min-width: 768px)').matches;
    if (this.isDesktop) {
      this.showProfile = true;
      this.openProfile();
    }
  }

  openProfile() {
    this.showProfile = true;
    this.showSubscription = false;
  }

  openSubscription() {
    this.showSubscription = true;
    this.showProfile = false;
  }

  handleBack() {
    if (this.showProfile) {
      this.showProfile = false;
    } else if (this.showSubscription) {
      this.showSubscription = false;
    } else {
      this.onBackClick.emit();
    }
  }

  logout() {
    this.authService.signOut();
  }
}
